module.exports = __webpack_public_path__ + "fonts/unicredit-italic.561a720e.eot";